import { requestWithToken } from '../utilities/request';

const path = '/api/private/fields';

/**
 * @param fieldId {int}
 */
const listFiles = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_shared_files/list`),
  });
};

/**
 * @param fieldId {int}
 * @param param {object}
 */
const bulkUpdate = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: `${path}/${fieldId}/field_shared_files/bulk_update`,
    data: param,
  });
};

/**
 * @param fieldId {int}
 * @param file {File}
 */
const tempFiles = (fieldId, file) => {
  const data = new FormData();
  data.append('file_data', file);
  return requestWithToken({
    method: 'POST',
    url: `${path}/${fieldId}/field_shared_files/temp_files`,
    processData: false,
    dataType: 'file',
    data,
    contentType: false,
  });
};

export const FieldFilesService = {
  listFiles,
  bulkUpdate,
  tempFiles,
};



// WEBPACK FOOTER //
// ./src/services/FieldFiles.js